export const isMessagePort = (sender) => {
    return typeof sender.start === 'function';
};
